import Backbone from 'backbone'
import template from './filter-source-dialog.hbs'
import FormView from 'scoreboard/components/form-view'
import widgetOptions from './widget-options'
import selects from '../../components/selects'
import formHelper from '../../components/form-helper'

/**
 * Dialog for selecting a the source of a dashboard widget's dataset filter
 * (ie the "Set Filter" dialog)
 */
const FilterSourceDialog = Backbone.View.extend({
	tagName: 'form',

	/** @type {FormWidget} */
	model: null,

	/** @type {Form} */
	form: null,

	initialize (options = {}) {
		this.form = options.form
	},

	render () {
		this.$el.append(template())

		this.renderWidgetDropdown()

		this.formView = new FormView({
			el: this.el,
			submit: this.done.bind(this)
		}).start()

		return this
	},

	renderWidgetDropdown () {
		let options = widgetOptions(
			this.form.get('widgets'),
			{ type: 'field' },
			{
				model: { dataset: this.form.dataset }
			})

		selects.filtering(this.$('[name=filterSourceWidgetId]'), {
			options,
			// #59912 Empty array to prevent sorting and preserve the order as
			// displayed on the form (just like form-action-editor)
			sort: [],
			selected: this.model.get('filterSourceWidgetId')
		})
	},

	val () {
		return formHelper.readFromDom(this.el).filterSourceWidgetId
	},

	done () {
		this.trigger('done')
	},

	autoRemove: true
})

export default FilterSourceDialog

FilterSourceDialog.__filename__ = 'forms/widgets/filter-source-dialog.js'
